import request from '@/utils/request'
export function getNotice(query) {
    return request({
        url: '/system/server-system/announce/list',
        method: 'get',
        params: query
    })
}
export function getNoticeDetail(id) {
    return request({
        url: '/system/server-system/announce/' + id,
        method: 'get'
    })
}
export function checkNoticeUnRead(query) {
    return request({
        url: '/system/server-system/announce/notReadlist',
        method: 'get',
        params: query
    })
}